// extracted by mini-css-extract-plugin
module.exports = {"pane":"ImagesPane-pane-1955","line":"ImagesPane-line-1955","image":"ImagesPane-image-1955"};